import { Card as MantineCard } from "@mantine/core";
import { Card } from "./card-component";
import { CardButton } from "./variants/button";
import { CardMetric } from "./variants/metric";
import { CardId } from "./variants/id";
import { CardAnomaly } from "./variants";

Card.Section = MantineCard.Section;
Card.Metric = CardMetric;
Card.Button = CardButton;
Card.Id = CardId;
Card.Anomaly = CardAnomaly;

export { Card };
